@let role = permissions.role();

@if (breakpoints().isDesktop) {
  <h1 class="title" [translate]="data().title"></h1>

  @if (role !== roleEnum.SuperAdmin) {
    <pp-rate-conditions class="rate" [role]="role" />
  }
} @else {
  <pp-logo-main class="logo" />
}

<div class="content">
  @if (role === roleEnum.SuperAdmin) {
    <pp-toggle-agent-account-sales />
  }

  @if (breakpoints().isTablet && role !== roleEnum.SuperAdmin) {
    <pp-team-selector class="team" />
  }

  <pp-user-card
    class="user"
    [user]="data().user"
    [onlyAvatar]="!breakpoints().isTablet"
    [organization]="
      getActiveOrg(storageStore.organizations(), storageStore.orgId())
    " />

  <!--  <pp-total-balance />-->
</div>
